"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideSections = void 0;
var React = __importStar(require("react"));
var guides_1 = require("../../../fixtures/guides");
var guideSection_1 = require("./guideSection");
// noinspection JSUnusedGlobalSymbols
exports.GuideSections = function (props) {
    var guideSlug = props.guideSlug, sections = props.sections, municipalities = props.municipalities;
    var guide = guides_1.Guides[guideSlug];
    return React.createElement("div", { className: "guider-show" },
        React.createElement("h1", null, guide.title),
        React.createElement("div", { className: "items" }, sections.map(function (section) {
            return React.createElement(guideSection_1.GuideSectionComponent, { key: section.title, section: section, municipalities: municipalities, includeSweden: false });
        })));
};
